import {
    AnimationBaseController,
    IAnimationControllerConfiguration,
    Inject,
    ModelEvents
} from "@denishussar/html5-game-engine";
import {GameModel} from "../../../../Models/Game/GameModel";
import {AnimationContents} from "../../../../../AnimationContents";
import {GameLogic} from "../../../../Logic/GameLogic";
import {ButtonCloseController, IButtonCloseControllerOptions} from "./ButtonCloseController";
import {ChoiceController, IChoiceControllerOptions} from "./ChoiceController";

export interface IRulesScreenControllerOptions {
}

export class SelectCharacterController extends AnimationBaseController {
    $model: GameModel;

    public constructor(@Inject private _options: IRulesScreenControllerOptions,
                       @Inject private _modelEvents: ModelEvents,
                       @Inject private _gameLogic: GameLogic) {
        super("SelectCharacterController");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            animationContent: AnimationContents.PLAYER_CHOICE_SCREEN_JSON,
            libraryName: "main",
            childControllers: {
                btn_close: {
                    instanceName: "container.window.btn_close",
                    view: ButtonCloseController,
                    options: <IButtonCloseControllerOptions>{
                        onClick: () => {
                            this.gotoAndPlayByQuery("container", "window close", false, false);
                            this.$queue.get('hide').addToQueue();
                        }
                    }
                },
                btn_ok: {
                    instanceName: "container.window.btn_ok",
                    view: ButtonCloseController,
                    options: <IButtonCloseControllerOptions>{
                        onClick: () => {
                            this.gotoAndPlayByQuery("container", "window close", false, false);
                            this.$queue.get('play').addToQueue();
                        }
                    }
                },
                characters_choice_man: {
                    instanceName: "container.window.characters_choice_man",
                    view: ChoiceController,
                    options: <IChoiceControllerOptions>{
                        type: 'man',
                        selected: true,
                        onClick: () => {
                            this.$model.isWoman = false;
                            this.$childControllers.get<ChoiceController>('characters_choice_woman').unselect();
                        }
                    }
                },
                characters_choice_woman: {
                    instanceName: "container.window.characters_choice_woman",
                    view: ChoiceController,
                    options: <IChoiceControllerOptions>{
                        type: 'woman',
                        onClick: () => {
                            this.$model.isWoman = true;
                            this.$childControllers.get<ChoiceController>('characters_choice_man').unselect()
                        }
                    }
                }
            },
            queue: {
                hide: {
                    condition: (clock: number) => clock > 0.3,
                    action: () => this._gameLogic.resetMenu()
                },
                play: {
                    condition: (clock: number) => clock > 0.3,
                    action: () => {
                        this._gameLogic.showGameScreen()
                    }
                }
            }
        };
    }

    protected onInitialize(): void {
        this.gotoAndPlayByQuery("container", "window initialization", false, false);
        this.$childControllers.get<ChoiceController>('characters_choice_man').select()
    }

    protected onLandscape(): void {
        this.display.scale.set(1.3);
        this.display.y = 25;
    }
}
